import styled from 'styled-components';
import { radius } from '@/styles/template';

const StyledCode = styled.pre`
	font-size: 2rem;
	overflow-x: auto;
	width: 100%;
	border-color: ${props => props.theme.color.LightItem};
	border-style: solid;
	border-width: 0 0 0 1rem;
	padding: 1.25rem;
	border-radius: ${radius.normal};
	box-shadow: inset 0 0 0 2px  ${(props) => props.theme.color.LightItem};
	
	& code {
		width: 100%;
		overflow: auto;
		border-radius: ${radius.normal};
	}
`;

export default StyledCode